import React from 'react';
import { DataTableColumn } from './DataTable';
import styles from './DataTableItem.module.scss';

interface Props<TItem, TTable> {
	item: TItem;
	table: TTable;
	columns: DataTableColumn<TItem, TTable>[];
	style?: React.CSSProperties;
}

export const DataTableItem = <TItem, TTable>({
	item,
	table,
	columns,
	style,
}: Props<TItem, TTable>): React.ReactElement => {
	return (
		<tr className={styles.wrapper} style={style}>
			{columns.map(column => (
				<td key={column.key} className={column.bold ? styles.boldItem : ''}>
					{column.renderItem(item, table)}
				</td>
			))}
		</tr>
	);
};

export default DataTableItem;
